import React, {useState} from 'react';

import {BookmarkIcon, UpvoteIcon} from './svg';
import {cx, formatLargeNum} from '../util';

export function SaveButton({initialValue, onClick, className}) {
  const [saved, setSaved] = useState(initialValue);

  const onSave = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setSaved(!saved);
    onClick(!saved);
  };

  return (
    <button
      type="button"
      className={cx('whitespace-nowrap flex items-center text-sm font-normal text-gray-500 hover:text-gray-600', className)}
      onClick={onSave}
    >
      <BookmarkIcon fill={saved ? 'currentColor' : 'none'} className="mr-1 h-4 w-4" />
      {saved ? 'Saved' : 'Save'}
    </button>
  );
}

export function UpvoteButton(props) {
  const {
    count,
    voted,
    onClick,
    large = false,
    numberOnly = false,
    className,
  } = props;

  let voteText;

  if (numberOnly) {
    voteText = formatLargeNum(count);
  } else if (count === 0) {
    voteText = 'Upvote';
  } else if (count === 1) {
    voteText = '1 vote';
  } else {
    voteText = `${formatLargeNum(count)} votes`;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cx(
        'font-semibold text-sm px-2.5 py-1 mr-1 rounded bg-transparent cursor-pointer transition-all flex items-center gap-1.5 whitespace-nowrap focus:outline-none',
        voted
          ? 'text-yellow-500 bg-yellow-100'
          : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700',
        large && (voted ? 'text-base border border-transparent' : 'text-base border border-gray-300 hover:border-transparent'),
        className,
      )}
    >
      <UpvoteIcon color={voted ? '#e9b600' : null} />
      {voteText}
    </button>
  );
}

